import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import Shape from './shape';

var Custom = /*#__PURE__*/function (_Shape) {
  _inherits(Custom, _Shape);

  var _super = _createSuper(Custom);

  function Custom() {
    _classCallCheck(this, Custom);

    return _super.apply(this, arguments);
  }

  _createClass(Custom, [{
    key: "_initProperties",
    value: function _initProperties() {
      _get(_getPrototypeOf(Custom.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = true;
      this._attrs.canStroke = true;
      this._attrs.createPath = null;
      this._attrs.type = 'custom';
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var createPath = this.get('createPath');
      createPath && createPath.call(this, context);
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var calculateBox = this.get('calculateBox');
      return calculateBox && calculateBox.call(this);
    }
  }]);

  return Custom;
}(Shape);

export default Custom;